/**
 * Oznámení klientům — `GET /api/announcements/` (marks seen) and
 * `POST /api/announcements/{id}/dismiss/`. Raw authedFetch until the next
 * `pnpm generate-api`.
 */
import { authedFetch } from '~/utils/authed-fetch'
import { getApiBase } from '~/utils/api-base'

export interface AnnouncementItem {
  id: number
  title: string
  body: string
  kind: string // info | success | warning
  display: string // modal | banner
  cta_label: string
  cta_url: string
}

export async function fetchAnnouncements(): Promise<AnnouncementItem[]> {
  try {
    const res = await authedFetch(`${getApiBase()}/api/announcements/`)
    if (!res.ok) return []
    const data = await res.json()
    return Array.isArray(data) ? data : []
  } catch {
    return []
  }
}

export function dismissAnnouncement(id: number): Promise<unknown> {
  return authedFetch(`${getApiBase()}/api/announcements/${id}/dismiss/`, { method: 'POST' }).catch(() => null)
}

/** Server-validated: `/`-relative SPA path or http(s) URL. */
export function openAnnouncementCta(url: string) {
  if (!url) return
  if (url.startsWith('/') && !url.startsWith('//')) {
    navigateTo(url)
  } else if (/^https?:\/\//i.test(url)) {
    window.open(url, '_blank', 'noopener')
  }
}
